<ion-button [id]="uuid" lines="none" fill="clear">
    <ion-icon name="information-circle-outline" size="small" color="medium"></ion-icon>
</ion-button>
<ion-popover [trigger]="uuid" (didDismiss)="didPopoverDismiss.emit()" side="bottom" alignment="center">
    <ng-template>
        <ion-content class="ion-padding" text-nowrap>
            {{helpMsg}}
        </ion-content>
    </ng-template>
</ion-popover>
